import VerticalButton from "./VerticalButton";

const Hero = () => {
  return (
    <div className="w-[80%] h-[100vh] relative top-0 flex flex-col">
      <div className="w-[80%] h-[100vh] flex flex-col justify-center ml-[20%] mt-4" >
        <div className="text-[70px] text-customGreen md:text-[100px] font-bold text-white ml-8">
          Hello<span className="text-customGreen">.</span>
        </div>
        <div className="flex flex-row items-center" data-aos="fade-up"
          data-aos-duration="960" data-aos-delay="150">
          <div className="h-1 w-16 bg-customGreen"></div>
          <span className="text-[20px] md:text-[25px] ml-4 text-white">I am Valerio Pescetelli</span>
        </div>
        <div className="text-[20px] text-white" data-aos="fade-up"
          data-aos-duration="1060" data-aos-delay="350">Software Engineer, Startupper & Innovation Specialist</div>
      </div>
      <div className="w-full flex justify-center items-center mb-[40px]">
        <VerticalButton />
      </div>
    </div>
  );
}

export default Hero;
